import { render, staticRenderFns } from "./iconSad.vue?vue&type=template&id=35321c4f"
import script from "./iconSad.vue?vue&type=script&lang=js"
export * from "./iconSad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports